import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-circular-progress',
    template: `
        <svg class="circular-progress__svg">
            <circle
                class="circular-progress__circle"
                [style.r]="radius + 'px'"
                cx="55"
                cy="55"
            />
            <circle
                class="circular-progress__circle circular-progress__circle--with-dash"
                [style.r]="radius + 'px'"
                cx="55"
                cy="55"
                [style.stroke-dashoffset]="dashoffset"
            />
        </svg>
        <span class="circular-progress__percentage">{{percentageValue}}%</span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircularProgressComponent {
    @HostBinding('class') class = 'circular-progress';
    @Input() set percentage(value: number) {
        this.percentageValue = value;
        this.dashoffset = this.circumference - value / 100 * this.circumference;
    }

    percentageValue: number;
    dashoffset: number;
    radius = 47;

    private pi = 3.14;
    private circumference = this.radius * 2 * this.pi;
}
